<template>
  <div>
    <div>
      <v-card style="margin: 10px">
        <v-card-title
          >{{ question.elementId }}: {{ question.questionText }}</v-card-title
        >
        <v-card-subtitle
          >Gestellt von: {{ question.questionerFullName }} am:
          {{
            question.createdDate | moment("DD.MM.YYYY HH:mm")
          }}</v-card-subtitle
        >
        <v-card-text>
          Bitte beantworten Sie die Frage:
          <v-text-field
            label="Antwort"
            :rules="rules"
            v-model="answer"
          ></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="answerQuestion()" text color="primary">Absenden</v-btn>
        </v-card-actions>
      </v-card>
    </div>

    <div
      style="
        position: absolute;
        top: 250px;
        left: calc(25% + 10px);
        right: 10px;
        bottom: 25px;
      "
      class="column"
    >
      <BpmnViewer :diagramXML="diagramXML" ref="viewer" @shown="loadColoredElements()"/>
    </div>
  </div>
</template>

<script>
import BpmnViewer from "@/pages/ProcessModeling/BpmnViewer";
import answerQuestionService from "./answer-question-service";
import processModelingService from "@/pages/ProcessModeling/process-modeling-service";
import colors from 'vuetify/lib/util/colors'
export default {
  components: {
    BpmnViewer,
  },
  data: () => ({
    diagramXML: null,
    answer: null,
    rules: [
      (value) => !!value || "Required.",
      (value) => (value && value.length >= 3) || "Min 3 characters",
    ],
  }),
  props: {
    question: Object,
  },
  computed: {
    userId() {
      return this.$store.getters.user.username;
    },
  },
  watch: {
    question: function (val) {
      this.question = val;
      this.fetchXML();
      this.loadColoredElements();
    },
  },
  mounted() {
    this.fetchXML();
    
  },
  methods: {
    loadColoredElements(){
      this.$refs.viewer.resetColorsInModel();
      this.$refs.viewer.colorElementInModel(this.question.elementId, colors.red.darken3, '');
    },
    answerQuestion() {
      answerQuestionService
        .answerQuestion(
          this.answer,
          this.question.id
        )
        .then((res) => {
          this.$emit("questionAnswered");
        });
    },
    fetchXML() {
      processModelingService
        .getProcessXml(this.question.uuidModel)
        .then((result) => {
          this.diagramXML = result.data;
        });
    },
  },
};
</script>
<style scoped>
</style>